<!-- 
TheRemoteDocumentWarning.vue
功能：準未訪件明細
作者：i9400538 陳博承
完成：2021-08-18
-->
<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <div
        class="mb-3"
        :class="{'section-loading': infoLoading}"
        style="overflow: hidden;max-height: 140px;"
      >
        <div class="float-left w-75">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <a
              v-if="categoryInfo.upload_file"
              class="text-orange"
              style="text-decoration:none;"
            >
              <i style="cursor:pointer;" class="icon-attach ml-2" @click="download()"></i>點我
            </a>
          </h4>
          <div class="mb-line" style>
            <span
              class="font-weight-bold mr-2"
            >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
          </div>
          <div class="mb-line w-75">
            <span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
              type="button"
              style="height:43px;"
              @click="backToIndex"
              class="position-absolute btn btn-default m-0"
              v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <remote-document-warning-data-table
          :height="data_table_height"
          @update="updateSelection"
          @missing-modal="openMissingModal"
          @scheduled-access="ScheduledAccess"
          @search="doSearch"
          :table-data="tableData"
          :categoryInfo="categoryInfo"
        />
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12"></div>
        <div class="col-3 col-sm-4 col-md-4"></div>
        <div class="col-9 col-sm-8 col-md-8 text-right">
          <button
            class="btn btn-primary"
            type="button"
            @click="sendBirthdayMsg"
            :disabled="!selection.length"
          >發送生日優禮訊息</button>
          <button
            type="button"
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            type="button"
            class="btn btn-primary mr-0"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal :open="printModalOpen" :custs="selection" @close="panelClose('printModalOpen')" />

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selectionOnlyIDs"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <!-- 滿意度調查 -->
    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />

    <!-- 失聯回報 -->
    <missing-modal
      :open="MissingModalOpen"
      :contact="missingContact"
      @submit="updateMissing"
      @close="panelClose('MissingModalOpen')"
    />

    <!-- 排訪 -->
    <scheduled-access
      :open="ScheduledAccessModalOpen"
      :record="currentRecord"
      :cat-info="categoryInfo"
      @close="panelClose('ScheduledAccessModalOpen')"
      @submit="submitScheduledAccess"
    />

    <!-- 發送訊息視窗(生日優禮&EDM) -->
    <send-msg-modal
      :open="sendMsgModalOpen"
      :cust="selection"
      :actionName="actionName"
      @close="panelClose('sendMsgModalOpen')"
      @sendMsgSubmit="sendMsgSubmit"
    />

    <!-- 寄送資格/訊息發送狀態視窗(生日優禮&EDM) -->
    <send-result-modal
      :open="sendResultModalOpen"
      :csid="csid"
      api_id="2"
      @close="panelClose('sendResultModalOpen')"
    />

    <!-- 警告視窗 -->
    <warning-modal
      :open="warningModalOpen"
      :showCancel="warningShowCancelBtn"
      message="提醒您，單次勾選要保人數上限50人，請重新選擇！"
      @close="panelClose('warningModalOpen')"
      @submit="panelClose('warningModalOpen')"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { saveAs } from "file-saver";
//component
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import RemoteDocumentWarningDataTable from "@/desktop/components/ListsArea/DataTable/RemoteDocumentWarningDataTable";
import SatisfactionModal from "@/desktop/components/ListsArea/SatisfactionModal";
import MissingModal from "@/desktop/components/ListsArea/MissingModal";
import ScheduledAccess from "@/desktop/components/ListsArea/ScheduledAccess";
import SendMsgModal from "@/desktop/components/ListsArea/SendMsgModal";
import SendResultModal from "@/desktop/components/ListsArea/SendResultModal";
import WarningModal from "@/desktop/components/WarningModal";
//service
import {
  getRemoteDocumentWarning,
  getCategoryDetail,
  isSatisfactionSurveyFinish,
  queryBookedVisitEvent,
  getRemoteDocumentWarningLost,
  downloadFile_m0,
  cancelMissingLost
} from "@/service";

export default {
  name: "TheRemoteDocumentWarning",
  mixins: [commonMixin],
  components: {
    RemoteDocumentWarningDataTable,
    SatisfactionModal,
    PrintModal,
    GroupModal,
    ScheduledAccess,
    MissingModal,
    SendMsgModal,
    SendResultModal,
    WarningModal
  },
  props: {
    status: String
  },
  data() {
    //data block layout
    return {
      isLoading_btn: true,
      isLoading: false,
      infoLoading: false,
      isBtnEnble: true,
      printModalOpen: false,
      groupModalOpen: false,
      visitList: [],
      tableData: [],
      selection: [],
      categoryInfo: {},
      satisfactionModalOpen: false,
      data_table_height: 0,
      ScheduledAccessModalOpen: false,
      currentRecord: {},
      info: {},
      IntegratedAddressModalOpen: false,
      missCustId: "",
      missingContact: "",
      MissingModalOpen: false,
      sendMsgModalOpen: false,
      sendResultModalOpen: false,
      warningModalOpen: false,
      warningShowCancelBtn: false,
      selectionOnlyIDs: [], //當前選取客戶的ID集合
      actionName: "", //發送類型主題
      csid: "", //當前點選客戶ID
      isShowCancel: false,
      visitNoList: []
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    updateSelection(val) {
      this.selection = [];
      let ids = [];
      val.forEach(item => {
        if (!ids.includes(item.id)) {
          ids.push(item.id);
          this.selection.push(item);
        }
      });
      this.selectionOnlyIDs = ids;
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    backToIndex() {
      // 回上一頁
      this.$emit("change-status", "STATUS_SERVICE_RIGHT_LIST");
    },
    download() {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(
          this.$store.state.userInfo.id,
          this.categoryInfo.ser_no,
          this.categoryInfo.upload_file
        ).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, this.categoryInfo.upload_file);
          }
        });
      }
    },
    submitGroup(group) {
      // 加入群組導頁至 群組列表
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    init() {
      // 資料初始化
      this.checkIsSatisfactionSurveyFinish();
      this.isLoading = true;
      getRemoteDocumentWarning(this.$store.state.userInfo.id, "3").then(
        result => {
          this.isLoading = false;
          if (
            result.header &&
            result.header.status === "200" &&
            result.body.estrange_list
          ) {
            let connect = "";
            let CsidData = "";
            let lists = result.body.estrange_list || [];
            lists.forEach(item => {
              connect = connect + "," + item.ceapcno;
            });
            if (connect.length > 0) {
              CsidData = connect.substr(1);
            }
            queryBookedVisitEvent(this.$store.state.userInfo.id, CsidData).then(
              visitData => {
                this.isLoading = false;
                if (visitData.header && visitData.header.status === "200") {
                  this.visitList = visitData.body.detail;
                  this.tableData = lists.map(item => {
                    let visit = { visit: {} };
                    this.visitList.forEach(vItem => {
                      if (vItem.csidno == item.ceapcno) {
                        visit.visit = vItem;
                      }
                    });
                    let idmark = item.idmark || ""; //客戶標記
                    let ageText = this.paddingLeft(
                      item.age == "0" ? "0" : item.age ? item.age : "00000",
                      4,
                      "0"
                    );
                    let birthdayText = item.birthday || "0000-01-01";
                    return {
                      id: item.ceapcno || "", //客戶id
                      sex: item.ceapcno[1] || "", //性別
                      name: item.ceapcnm, //要保人姓名
                      ceplcno: item.ceplcno, //保單號碼
                      csname: item.csname || "", //客戶姓名
                      idmark: item.idmark || "", // 客戶標記
                      ceplcdt: item.ceplcdt, //投保日
                      ceagnnm: item.ceagnnm || "", //經手人姓名
                      ceclcid: item.ceclcid || "", //收費人ID
                      ceclcno: item.ceclcno || "", //收費代號
                      pay_type_nm: item.pay_type_nm || "", //繳費管道
                      celpscs_nm: item.celpscs_nm || "", //契約效力
                      cenxpdt: item.cenxpdt || "", //下次應繳日
                      contact: item.contact || "", //失聯狀況，若無，會是空字串
                      contact_nm: item.contact_nm || "", //失聯狀況_中文描述，若無，會是空字串
                      visit_no: item.visit_no || "", //拜訪編號，存失聯件用
                      producer_segment: item.producer_segment, //推薦原因
                      is_exist: item.is_exist || false, //判斷是否有客戶資料
                      addr: (item.home_addr_zip || "") + (item.home_addr1 || "") + (item.home_addr2 || "") + (item.home_addr3 || ""), 
                      email: item.email || "", //信箱
                      mobile: item.mobile || "", //手機
                      birthday: item.birthday || "", //生日
                      birthdaySort: ageText + "_" + birthdayText, //生日排序用
                      age: item.age == undefined ? "" : item.age.toString(), //客戶年齡
                      cathay_no: item.cathay_no || "",
                      isShow_B: idmark ? idmark.includes("B") : false, //符合生日優禮Email寄送資格
                      isShow_M: idmark ? idmark.includes("M") : false, //符合生日優禮簡訊寄送資格
                      isShow_I: idmark ? idmark.includes("I") : false, //符合EDM寄送資格
                      ...visit // 寫入排訪資料
                    };
                  });
                }
              }
            );
            this.registerHanlink(); // for hard word
          }
        }
      );
      this.getTitleInfo();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status == "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status == "200") {
          this.isBtnEnble = result.body.isfinish == "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    openMissingModal(custId, contact, visit_no) {
      // 是否失聯
      this.missCustId = custId;
      this.missingContact = contact;
      this.isShowCancel = contact ? true : false //有回報過才顯示取消失聯的按鈕
      this.visitNoList = [];
      this.visitNoList.push(visit_no);
      this.panelOpen("MissingModalOpen");
    },
    updateMissing(val) {
      // 更新失聯
      getRemoteDocumentWarningLost(
        this.$store.state.userInfo.id,
        this.missCustId,
        val,
        false
      ).then(result => {
        if (result && result.header.status == "200" && result.body) {
          this.setToastMsg(result.header.message);
        } else {
          this.setToastMsg(result.header.message);
        }
        this.panelClose("MissingModalOpen");
        this.init();
      });
    },
    //取消失聯
    cancelMissing() {
      cancelMissingLost(
        this.$store.state.userInfo.id,
        this.visitNoList
      ).then(result => {
        if (result && result.header.status == "200" && result.body) {
          this.setToastMsg(result.header.message);
        } else {
          this.setToastMsg(result.header.message);
        }
        this.panelClose("MissingModalOpen");
        this.initRemoteDocumentWarning();
      });
    },
    ScheduledAccess(record) {
      this.currentRecord = record;
      this.panelOpen("ScheduledAccessModalOpen");
    },
    submitScheduledAccess() {
      this.panelClose("ScheduledAccessModalOpen");
      // 資料初始化
      this.init();
    },
    //發送生日優禮訊息
    sendBirthdayMsg() {
      if (this.selection && this.selection.length > 50) {
        this.panelOpen("warningModalOpen");
        return;
      }
      this.actionName = "生日優禮訊息";
      this.panelOpen("sendMsgModalOpen");
    },
    //發送EDM
    sendEdmMsg() {
      if (this.selection && this.selection.length > 50) {
        this.panelOpen("warningModalOpen");
        return;
      }
      this.actionName = "EDM";
      this.panelOpen("sendMsgModalOpen");
    },
    //發送主題完成後的確認
    sendMsgSubmit() {
      this.panelClose("sendMsgModalOpen");
    },
    //查詢寄送資格/訊息發送狀態
    doSearch(val) {
      this.csid = val;
      this.panelOpen("sendResultModalOpen");
    }
  },
  mounted() {
    // 資料初始化
    this.init();
    this.data_table_height =
      parseInt($(window).height()) - $("tbody").offset().top - 80;
    let self = this;
    $(window).bind("resize", function() {
      self.data_table_height =
        parseInt($(window).height()) - $("tbody").offset().top - 80;
    });
    $(".tab-content").css("padding-bottom", "74px");
  }
};
</script>
